<template>
	<div>
		<sky-card :title="'联系人信息'" >
			<!-- <div slot="header-btns" @click="add" class="del-btn" v-if="garbageFlag!=1">添加</div> -->
			<div class="card-content" v-if="contactlist.length > 0" ref="box">
				<div class="sub-title">
					<span>联系人({{ contactlist.length }})</span>
				</div>
				<div v-for="(item, index) in contactlist" :key="index" class="container">
					<div>
						<div class="info16" v-if="item.aiFlag==1">
							<ig-icon name="fluorescent"></ig-icon>此数据由AI大数据洞察引擎提供
						</div>
						<div class="content">
							<div class="form">
								<!-- <clueContactForm
									v-if="showEdit == index"
									:attributes="item"
									@cancel="cancel(item.id, index)"
									@submit="data => update(data, item.id)"
								></clueContactForm> -->
							</div>
							<div v-show="showEdit != index">
								<el-row type="flex">
									<el-col class="label1">联系人名称</el-col>
									<el-col class="value1">
										{{ item.contactName }}
										<ig-icon name="bianji2" class="blue" @click.native="edit(index)" v-if="garbageFlag!=1"></ig-icon>
									</el-col>
								</el-row>
								<el-row type="flex">
									<el-col class="label1">联系电话</el-col>
									<el-col class="value1" v-if="item.phone.length">{{ item.phone | phoneFilters }}</el-col>
									<el-col class="value1" v-else>-</el-col>
								</el-row>
								<el-row type="flex">
									<el-col class="label1">邮箱</el-col>
									<el-col class="value1">{{ item.email || '-' }}</el-col>
								</el-row>
								<el-row type="flex">
									<el-col class="label1">职位</el-col>
									<el-col class="value1">{{ item.contactJob || '-' }}</el-col>
								</el-row>
								<el-row type="flex">
									<el-col class="label1">性别</el-col>
									<el-col class="value1">{{ item.sex | textFilters }}</el-col>
								</el-row>

								<!-- <el-row type="flex" v-for="(ele, index) in item.contactSns" :key="index">
									<el-col class="label1">{{ ele.snsName || 'SNS' }}</el-col>
									<el-col class="value1">{{ ele.snsContent || '-' }}</el-col>
								</el-row> -->
										<div v-if="item.contactSns&&item.contactSns.length">
									<el-row type="flex" v-for="(ele, index) in item.contactSns" :key="index">
										<el-col class="label1">{{ ele.snsName || '社交平台' }}</el-col>
										<el-col class="value1">{{ ele.snsContent || '-' }}</el-col>
									</el-row>
								</div>
								<div v-else>
									<el-row type="flex">
										<el-col class="label1">社交平台</el-col>
										<el-col class="value1">-</el-col>
									</el-row>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="no-content">暂无数据</div>
		</sky-card>
	</div>
</template>
<script>
import chatSer from '@/backend/services/chat/chatSer.js';
// import modifyingContacts from '@/components/crm/customer/modifyingContacts.vue';
// import clueContactForm from '@/components/iglobalwin/form-warps/clueContactForm.vue';
import skyCard from '@/components/iglobalwin/sky-card.vue';
import { mapGetters } from 'vuex';
export default {
	props: {
		id: {
			type: String,
		},
		companyDataInfo: {
			type: Object,
		},
		isCollapse: {
			type: Boolean,
			default: true,
		},
		garbageFlag: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			editVisible: false,
			showEdit: -1,
			contactlist: [],
		};
	},
	filters: {
		textFilters(val) {
			if (String(val) === '0') {
				return '女';
			} else if (val == 1) {
				return '男';
			} else {
				return '-';
			}
		},
		phoneFilters(val) {
			if (Array.isArray(val)) {
				return val.join(',');
			} else {
				return '-';
			}
		},
	},
	// computed: {
	// 	...mapGetters(['contactlist']),
	// },
	watch: {

		id: {
	handler(val) {
		if (val) {
			this.getData();
		}
	},
	immediate: true,
},
},
	mounted() {
		this.getData();
	},
	methods: {
		async getData() {
			const res = await chatSer.getContactlist({
				id: this.id,
				type:2
			});
			this.contactlist = res.data;
		},
		edit(index) {
			this.showEdit = index;
		},
		async update(data, id) {
			data.contactSns = data.contactSns.filter(item => {
				delete item.id;
				return item.snsContent !== '' && item.snsName !== '';
			});
			if (id) {
				const res = await custSer.modifyContact({
					id,
					customerId: this.id,
					...data,
				});
				if (res) {
					this.showEdit = -1;
					this.getData();
					this.$emit('getList');
				}
			} else {
				const res = await custSer.addContact({
					customerId: this.id,
					...data,
				});
				if (res) {
					this.showEdit = -1;
					this.getData();
					this.$emit('getList');
				}
			}
		},
		cancel(id, index) {
			this.showEdit = -1;
			if (!id) {
				this.contactlist.splice(index, 1);
			}
		},
		add() {
			if (this.showEdit == -1) {
				this.contactlist.unshift({
					contactJob: '',
					contactName: '',
					email: '',
					id: '',
					customerId: '',
					item: '',
					line: '',
					massage: '',
					phone: '',
					sex: '',
					sns: '',
					wechat: '',
					whatsApp: '',
				});

				this.showEdit = 0;
			}
		},
	},
	components: { 
		// modifyingContacts, 
		// clueContactForm, 
		skyCard },
};
</script>
<style lang="scss" scoped>
.info16 {
	overflow-wrap: break-word;
	color: rgba(255, 188, 49, 1);
	font-size: 14px;
	font-weight: 600;
	font-family: PingFangSC-Regular;
	white-space: nowrap;
	line-height: 20px;
}
.card-content {
	padding-bottom: 40px;
}

.container {
	width: 100%;
	padding: 0 30px;
	margin-top: 20px;
}

.content {
	width: 100%;
	padding: 15px 20px;
	background: #f8f9fc;
	border-radius: 4px;
}

.label1 {
	width: 110px !important;
	padding: 5px 0;
	text-align: right;
}

.value1 {
	padding: 5px 12px;
	color: #333;
	word-break: break-all;
	text-align: left;
	display: inline-block;
	word-wrap: break-word;
}

.blue {
	color: #3da1ff;
	margin-left: 5px;
	cursor: pointer;
}

.del-btn {
	color: #3da1ff;
	float: right;
	cursor: pointer;
}

.sub-title {
	width: 100%;
	margin: 20px 30px;
}

.no-content {
	text-align: center;
	height: 50px;
	color: #999;
}
</style>
